// Only navigate inside the current document. External/action annotations are
// deliberately left to the original PDF; they must not execute in a preview.
export async function getPdfInternalLinks(pdf, page, viewport) {
  if (!page.getAnnotations) return [];
  let annotations;
  try { annotations = await page.getAnnotations({ intent: 'display' }); }
  catch { return []; }
  if (!Array.isArray(annotations)) return [];
  const links = await Promise.all(annotations.map(async (annotation, index) => {
    try {
      if (annotation.subtype !== 'Link' || !annotation.dest || !Array.isArray(annotation.rect)
        || annotation.rect.length !== 4 || !annotation.rect.every(Number.isFinite)) return null;
      const destination = typeof annotation.dest === 'string'
        ? await pdf.getDestination(annotation.dest) : annotation.dest;
      if (!Array.isArray(destination) || !destination.length) return null;
      const reference = destination[0];
      const pageIndex = Number.isInteger(reference) ? reference
        : reference && Number.isInteger(reference.num) && Number.isInteger(reference.gen)
          ? await pdf.getPageIndex(reference) : NaN;
      if (!Number.isInteger(pageIndex) || pageIndex < 0 || pageIndex >= pdf.numPages) return null;
      const rect = viewport.convertToViewportRectangle(annotation.rect);
      if (!rect.every(Number.isFinite)) return null;
      const left = Math.max(0, Math.min(rect[0], rect[2]));
      const top = Math.max(0, Math.min(rect[1], rect[3]));
      const right = Math.min(viewport.width, Math.max(rect[0], rect[2]));
      const bottom = Math.min(viewport.height, Math.max(rect[1], rect[3]));
      if (right <= left || bottom <= top) return null;
      return { key: String(index), pageNumber: pageIndex + 1, left, top, width: right - left, height: bottom - top };
    } catch { return null; }
  }));
  return links.filter(Boolean);
}
